import React from 'react';
import './HomeItem.css'

function HomeItem(props) {
    var carouselid = 'carousel' + Math.random();
  return (
    <div className='home-col h-[393px] w-[411px] px-3 py-4 rounded-xl border border-[#BDBDBD]'>
        <div className='home-item relative'>
            <div id= {carouselid} className="carousel slide h-[247px]" data-ride="carousel">
                {/* <ol className="carousel-indicators">
                    <li data-target={'#' +carouselid} data-slide-to="0" className="active"></li>
                    <li data-target={'#' +carouselid} data-slide-to="1"></li>
                    <li data-target={'#' +carouselid} data-slide-to="2"></li>
                </ol> */}
                <div className="carousel-inner">
                    {/* <div className="carousel-item active"> */}
                    {props.src.map((item, index) => (
                                    
                        <div key={index} className={index===0 ? "carousel-item active":( console.log(index),"carousel-item")}>
                            <img className="d-block md:w-full h-[247px] phone:mx-4 w-[97%] phone:w-[90%] rounded-[11px]" src={item} alt="slide"/>
                        </div>
                    ))}
                    {/* <img className="d-block w-100" style ={{height: "345px"}} src={props.src} alt="First slide"/>
                    </div>
                    <div className="carousel-item">
                    <img className="d-block w-100" style ={{height: "345px"}} src={props.src} alt="Second slide"/>
                    </div>
                    <div className="carousel-item">
                    <img className="d-block w-100" style ={{height: "345px"}} src={props.src} alt="Third slide"/>
                    </div> */}
                </div>
                <a className="carousel-control-prev" href={'#' +carouselid} role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="carousel-control-next" href={'#' +carouselid} role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                </a>
            </div>
            {/* <img src={props.src} alt={props.alt}/> */}
            {/* <div className='home-detail'> */}
            <p className='absolute -mt-14 md:ml-3 phone:ml-7 bg-[#E0F9EA] rounded-sm p-1 text-[#0B1911] text-sm'> Starting at N {Number(props.amount).format()}</p>
            <div className=' phone:px-4'>
            <a href={'/home?id='+props.id} >
                <div className='home-title pt-2'>
					
						<p className='text-md font-bold text-[#0B1911] text-capitalize'>{props.name}</p>
					
                </div>
                <div className='home-property'>
                    <p className='subtext-3'>{props.bed} beds</p> 
                    <span className='home-property-separator'></span>
                    <p className='subtext-3'>{props.bath} baths</p>
                </div>
                
                
                {/* {props.shared === "Shared Space" ? (<p className='split'><span className='split-text'>Rent split available</span></p>):""} */}
            </a>
                {/*<div className="home-likes">
                     <img src='./images/img-1.jpg' className="imgliked" />
                    <img src='./images/img-1.jpg' className="imgliked imgtoleft" /> 
                    <p><a href={'/likes'} >{props.likes} </a> people are interested</p>
                </div>
                */}
                
            </div>  
        </div>
        {/* <script>$('.carousel').carousel()</script> */}
    </div>
    
  );
}

export default HomeItem;